import * as fromDatatype from '../datatype-library/index';

export interface bl_fi_cashbook_txn_stmt_recon_possible_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    cash_stmt_hdr_guid: fromDatatype.GuidDataFieldInterface;
    cash_stmt_line_guid: fromDatatype.GuidDataFieldInterface;
    cashbook_txn_line_guid: fromDatatype.GuidDataFieldInterface;
    bank_recon_hdr_guid: fromDatatype.GuidDataFieldInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    txn_date: fromDatatype.TimestampTzDatatypeInterface;
    logic: fromDatatype.VarcharDatatypeInterface;
    option: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    amount_contra: fromDatatype.NumericDatatypeInterface;
    amount_signum: fromDatatype.NumericDatatypeInterface;
    cost_function: fromDatatype.NumericDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
	
}


export class bl_fi_cashbook_txn_stmt_recon_possible_link_RowClass implements bl_fi_cashbook_txn_stmt_recon_possible_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    cash_stmt_hdr_guid: fromDatatype.GuidDataFieldInterface;
    cash_stmt_line_guid: fromDatatype.GuidDataFieldInterface;
    cashbook_txn_line_guid: fromDatatype.GuidDataFieldInterface;
    bank_recon_hdr_guid: fromDatatype.GuidDataFieldInterface;
    txn_type: fromDatatype.VarcharDatatypeInterface;
    txn_date: fromDatatype.TimestampTzDatatypeInterface;
    logic: fromDatatype.VarcharDatatypeInterface;
    option: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    remarks: fromDatatype.VarcharDatatypeInterface;
    amount_contra: fromDatatype.NumericDatatypeInterface;
    amount_signum: fromDatatype.NumericDatatypeInterface;
    cost_function: fromDatatype.NumericDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}

